import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthService } from '../../../service';
import { useSearchQuery } from '../../../../shared/hooks/useSearchQuery';
import { ErrorToast, SuccessToast } from '../../../../utils/toasters';
import { StepperButtons } from './StepperButtons';
import { useNavigate } from 'react-router-dom';
import registrationSlice from '../../../../store/register/brand/registrationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { Col, Form, Row } from 'react-bootstrap';
import { IRegistrationStepTwoRequest } from '../dto/IRegistrationStepTwoRequest';
import { IRegisterStepperProps } from '../../../../model/shared/IRegistration';
import VerificationField from './VerificationField';

export const Step2 = ({ stepIdNumber, handleBackStep }: IRegisterStepperProps) => {
    const savedData = useSelector((state: IAllStates) => state.registration);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const token = useSearchQuery('token') as string;
    const utmCampaign = localStorage.getItem('utmCampaign') as string;

    const [confirmationToken, setConfirmationToken] = useState<IRegistrationStepTwoRequest>({
        confirmationToken: '',
        utmCampaign,
    });

    useEffect(() => {
        if (!!token?.length) {
            AuthService.getUserDataById('registerBrand', token)
                .then(response => {
                    dispatch(registrationSlice.actions.setRegisterUser(response));
                })
                .catch(error => ErrorToast(error));
        }
    }, [token]);

    useEffect(() => {
        if (savedData?.isEnabled) {
            navigate(`/brand/register/${stepIdNumber + 1}?token=${savedData?.verificationUUID}`);
        }
    }, [savedData]);

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setConfirmationToken(prev => ({ ...prev, [name]: value }));
    };

    const handleNextStep = () => {
        AuthService.verifyUserData(token, confirmationToken)
            .then(response => {
                if (response) {
                    navigate(`/brand/register/${stepIdNumber + 1}?token=${response?.verificationUUID}`);
                    localStorage.removeItem('utmCampaign');
                    SuccessToast(t('auth.register.brand.step2.successCode'));
                }
            })
            .catch(error => ErrorToast(error));
    };

    const resendVerify = () => {
        setIsLoading(true);
        AuthService.resetVerifyCode(savedData?.email)
            .then(() => {
                SuccessToast(t('auth.register.brand.step1.pleaseCheckEmail'));
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsLoading(false));
    };

    return (
        <Form
            className="w-100"
            onSubmit={e => {
                e.preventDefault();
                handleNextStep();
            }}
        >
            <Row className="justify-content-center">
                <VerificationField
                    changeHandler={changeHandler}
                    resendVerify={resendVerify}
                    isLoading={isLoading}
                    confirmationToken={confirmationToken?.confirmationToken}
                />
                <Col xs={12} className="mt-4">
                    <StepperButtons
                        currentStep={stepIdNumber - 1}
                        handleNextStep={handleNextStep}
                        isBackHidden={true}
                        handleBackStep={handleBackStep}
                    />
                </Col>
            </Row>
        </Form>
    );
};
